// extracted by mini-css-extract-plugin
export default {"Container":"Terms_Container__QtSy1"};